import {
  DestroyRef,
  Directive,
  ElementRef,
  Input,
  Optional,
  Renderer2,
  OnInit,
} from '@angular/core';
import { TuiDropdownOpenDirective } from '@taiga-ui/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[tuiDropdownOpen][appOnDropdownOpen]',
  standalone: true,
})
export class OnDropdownOpenDirective implements OnInit {
  private readonly defaultClassName = 'context-menu-opened';
  @Input() appOnDropdownOpen = this.defaultClassName;
  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    @Optional()
    private readonly dropdownOpenDirective: TuiDropdownOpenDirective,
    private readonly destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    if (!this.dropdownOpenDirective) {
      return;
    }

    this.dropdownOpenDirective.tuiDropdownOpenChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(isOpened => {
        const className = this.appOnDropdownOpen || this.defaultClassName;
        if (isOpened) {
          this.renderer.addClass(this.el.nativeElement, className);
        } else {
          this.renderer.removeClass(this.el.nativeElement, className);
        }
      });
  }
}
